import RsaRedirect from './rsa-redirect';
export default RsaRedirect;